import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { TiLockClosed, TiLockOpen } from 'react-icons/ti';
import { MdMoreHoriz } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import fileSize from './../../../utils/fileSize';

import './PartnerMaterialItem.scss';

PartnerMaterialItem.propTypes = {
    file: PropTypes.object,
    thumbURL: PropTypes.string
};

function PartnerMaterialItem(props) {
    const { t } = useTranslation();
    const { file, thumbURL } = props;
    const [ deleted, setDeleted ] = useState(false);
    const [ hide, setHide ] = useState(false);

    const _deleteCallBack = () => {
        setDeleted(true);
        let timer = setTimeout(() => {
            setHide(true);
        }, 200);
        return () => clearTimeout(timer);
    }

    return (
        <div key={file.eventsPartnersFileId} className={"PartnerMaterialItem align-items-center " + (deleted ? 'deleted' : '') + (hide ? ' hidden' : '')}>

            <div
                className="thumbnail"
                style={{background: `url("${thumbURL}") no-repeat center #F0F0F0`}}>
            </div>

            <Row className="align-items-center item-row">
                <Col md={5}>
                    <span className="filename">
                        {file.material.name}{file.material.fileExtension}
                    </span>
                </Col>
                <Col md={2}>
                    <span className="filesize">
                        {fileSize(file.material.fileSize)}
                    </span>
                </Col>
                <Col md={2}>
                    <span className="timestamp">
                        {moment(file.material.timeCreated).format('DD.MM.YYYY HH:mm')}
                    </span>
                </Col>
                <Col md={2} className="text-center">
                    <span className="isPublic">
                        {file.material.isPublic ?
                            <TiLockOpen className="green" /> :
                            <TiLockClosed className="blue" />}
                    </span>
                </Col>
                <Col md={1}>
                    <Dropdown>
                        <Dropdown.Toggle as="span" className="no-caret">
                            <MdMoreHoriz className="more-icon" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight>
                            {/*<Dropdown.Item onClick={() => props.onEdit(file.material.materialID)}>Muokkaa</Dropdown.Item>*/}
                            <Dropdown.Item onClick={() => props.onDownload(file.material.materialID)}>{t('general.open_file')}</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item onClick={() => props.onDelete(file.eventsPartnersFileId, _deleteCallBack)}>{t('general.delete')}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
        </div>
    )
}

export default PartnerMaterialItem;